<style>
.el-collapse-item__header {
  padding-left: 15px;
}
.el-upload--picture-card {
  float: left;
  margin-right: 10px;
}
.circle-closesty {
  position: relative;
  top: -35px;
  margin-left: 112px;
  font-size: 20px;
  cursor: pointer;
}
.v-modal {
  z-index: 100 !important;
}
.select-box {
  overflow: hidden;
  margin: 0 0px 10px 30px;
}
.box-left {
  width: 40%;
  height: 350px;
  padding: 0 20px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
  overflow-y: auto;
}
.box-right {
  width: 57%;
  height: 350px;
  padding: 0 10px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
}
.function-wrap{
  position: relative;
  /* height: 50px; */
  line-height: 50px;
  /* padding: 10px 20px; */
  box-sizing: border-box;
  text-align: center;
  border-bottom: 1px solid #D9D9D9;
  background: #fff;
}

.back-btn{
  position: absolute;
  top: 12px;
  left: 10px;
  width: 64px;
  height: 20px;
  line-height: 20px;
  font-size: 12px;
  color: #323233;
  text-align: center;
  cursor: pointer;
  border: 1px solid #c8c9cd;
}
</style>
<template>
  <div class="content">
    <div class="search-area">
      <el-row :gutter="24">
        <el-col :span="8"
          ><div class="search-area-div" style="width: 102px; font-size: 14px">应用公司：</div>
          <el-select
            size="mini"
            @change="handleChangeCompany"
            v-model="page.tenantGuid"
            clearable filterable
            placeholder="请选择"
            class="fl"
            style="width: 260px"
          >
            <el-option
              v-for="item in sendTenantList"
              :key="item.sendTenantGuid"
              :label="item.sendTenantName"
              :value="item.sendTenantGuid"
            ></el-option>
          </el-select>
        </el-col>
        <el-col :span="8"
          ><div class="search-area-div" style="width: 102px; font-size: 14px">应用部门：</div>
          <el-select
            size="mini"
            v-model="page.organisationGuid"
            clearable filterable
            placeholder="请选择执行部门"
            class="fl"
            style="width: 260px"
          >
            <el-option
              v-for="item in organisationList"
              :key="item.guid"
              :label="item.organisationName"
              :value="item.guid"
            ></el-option>
          </el-select>
        </el-col>
        <div style="float: left">
          <el-button size="mini" type="info" @click="search">搜索</el-button>
          <el-button size="mini" type="danger" @click="emptySearch">清空</el-button>
        </div>
      </el-row>
    </div>

    <div class="back-color-fff content-main-box"  :style="'height:' + contentMainHeight + 'px;'">
      <div class="button-area">
        <el-button icon="el-icon-plus" size="mini" type="info" @click="addVersion">添加规则</el-button>
      </div>

      <el-table :data="tableData" stripe border style="width: 100%" v-loading="tableLoading" :height="height">
        <el-table-column label="序号" width="60" header-align="center" align="center" fixed="left">
          <template slot-scope="scope">
            <!-- {{ scope.$index + 1 }} -->
            {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column prop="tenantName" label="应用公司" show-overflow-tooltip header-align="center" align="left" fixed="left">
          <template slot-scope="scope">{{ scope.row.tenantName }}</template>
        </el-table-column>
        <el-table-column prop="organisationName" label="应用部门" header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.organisationName||'-' }}</template>
        </el-table-column>
        <el-table-column prop="stopReason" label="停线原因" header-align="center" align="left" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.stopReason}}</template>
        </el-table-column>
        <el-table-column prop="inputTime" label="是否需要回补" header-align="center" align="left" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.isNeedMend=='Y'?'是':'否' }}</template>
        </el-table-column>
        <el-table-column prop="inputTime" label="是否限制次数" header-align="center" align="left" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.isLimitCount=='Y'?'是':'否' }}</template>
        </el-table-column>
        <el-table-column prop="inputTime" label="限制次数" header-align="center" align="left" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.isLimitCount=='Y'?scope.row.limitStopDays+'天':'-' }}</template>
        </el-table-column>
        <el-table-column prop="tenantName" label="界面排序"  header-align="center" align="left" >
          <template slot-scope="scope">{{ scope.row.orderNum||'-' }}</template>
        </el-table-column>
        <el-table-column prop="bank" min-width="100px" label="操作" header-align="center" align="center">
          <template slot-scope="scope">
            <a class="txt-color" @click="editVersion(scope.row.guid)">编辑 ｜</a>
            <a class="txt-color" @click="delVersion(scope.row.guid)">删除</a>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      class="pt pb back-color-fff content-pagination-box"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[10, 20, 50, 100]"
      :current-page="page.pageIndex"
      :page-size="page.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="page.totalRows"
    >
    </el-pagination>
  </div>
</template>

<script>
import { route } from '@/api/apiRoute';
import store from '@/store';
export default {
  data() {
    return {
      fullscreenLoading: false,
      textTitle: '新增任务大类',
      page: {
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
        tenantGuid: this.$route.query.tenantGuid,
        organisationGuid: this.$route.query.organisationGuid,
      },
      guid: '',
      contentMainHeight: window.innerHeight - 200,
      height: window.innerHeight - 280,
      right: 'right',
      tableData: [],
      dialogVisible: false,
      sendTenantList: [],
      organisationList: [],
      subTitle:"",
    };
  },
  created() {
    this.getList();
    this.getSendTenantList();
  },
  watch: {},
  methods: {
    search() {
      let self = this;
      self.tableLoading = true;
      self.api.postJson(`/${serverConfig.msConfigureService}/line-stop-rule/list`, this.page).then((res) => {
        self.tableLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableData = res.data.data.records;
          self.page.totalPage = res.data.data.totalPages;
          self.page.totalRows = res.data.data.totalRows;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    emptySearch() {
      this.page = {
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
        tenantGuid: '',
        organisationGuid: '',
      };
      this.getList();
    },
    //新增
    addVersion() {
      let tenantGuid = this.page.tenantGuid;
      let organisationGuid = this.page.organisationGuid;
      this.$router.push({
        path: 'lineStopRuleEdit',
        query: {
          tenantGuid,
          organisationGuid,
          productGuid: this.$route.query.productGuid
        },
      });
    },
    //编辑
    editVersion(guid) {
      this.$router.push({
        path: 'lineStopRuleEdit',
        query: {
          guid: guid,
          productGuid: this.$route.query.productGuid
        },
      });
    },
    getList() {
      let self = this;
      self.tableLoading = true;
      self.api.postJson(`/${serverConfig.msConfigureService}/line-stop-rule/list`, this.page).then((res) => {
        self.tableLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableData = res.data.data.records;
          self.page.totalPage = res.data.data.totalPages;
          self.page.totalRows = res.data.data.totalRows;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    delVersion(guid) {
      var self = this;
      var req = [guid];
      self
        .$confirm('删除后不可恢复，确定删除吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
        .then(() => {
          self.api.postJson(`/${serverConfig.msConfigureService}/line-stop-rule/del`, req).then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.$message.success('删除成功');
              self.page.pageIndex = 1;
              self.getList();
            } else {
              self.$message.error(res.data.msg);
            }
          });
        });
    },
    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val;
      this.getList();
    },
    getSendTenantList() {
      let self = this;
      let query = {
        isService: true,
        tenantGuid: localStorage.guid,
      };
      self.api
        .get(`/${serverConfig.msCustomerService}/tenant/data/get-tenant-operation-rel-list`, query)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.sendTenantList = res.data.data;
            if(this.$route.query.tenantGuid){
              let req = {
                pageIndex: 1,
                pageSize: -1,
                tenantGuid: this.$route.query.tenantGuid,
              };
              self.api.postJson(`/${serverConfig.msPersonnelService}/organisation/data/get`, req).then((data) => {
                if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                  self.organisationList = data.data.data.records;
                } else {
                  self.$message.error(data.data.msg);
                }
              });
            }
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    handleChangeCompany(v) {
      let self = this;
      if(!v){
        self.page.organisationGuid = '';
        return;
      };
      let query = {
        pageIndex: 1,
        pageSize: -1,
        tenantGuid: v,
      };
      self.api.postJson(`/${serverConfig.msPersonnelService}/organisation/data/get`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.page.organisationGuid = '';
          self.organisationList = res.data.data.records;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
  },
};
</script> 
<style scoped>
.content h1 {
  margin: 0;
  /* margin-bottom: 16px; */
  font-size: 18px;
}
.el-table /deep/ .el-input__inner {
  height: 40px;
  line-height: 40px;
}
.el-range-editor.el-input__inner {
  padding: 0px;
}
/deep/ .el-checkbox__label {
  display: none;
}
.attach-sty {
  width: 170px;
  float: left;
  margin-top: 15px;
  text-align: center;
}
.checkbox-img-sty {
  border: 1px solid #dcdfe6;
  width: 16px;
  height: 16px;
  border-radius: 2px;
  cursor: pointer;
}
/deep/ .el-step__icon.is-text {
  border-radius: 50%;
  border-color: #4fa1a4;
  border-color: inherit;
}
/deep/ .el-step__icon-inner {
  color: #4fa1a4;
}
/deep/ .el-step__title.is-process {
  color: #4fa1a4;
}
.content-main-box {
  height: auto;
}
</style>